import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const HambergerIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "HambergerIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.2293 6.72356H2.77072C2.34522 6.72356 2 6.37834 2 5.95285C2 5.52735 2.34522 5.18213 2.77072 5.18213H21.2293C21.6548 5.18213 22 5.52735 22 5.95285C22 6.37834 21.6548 6.72356 21.2293 6.72356Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.2293 12.7714H2.77072C2.34522 12.7714 2 12.4262 2 12.0007C2 11.5752 2.34522 11.23 2.77072 11.23H21.2293C21.6548 11.23 22 11.5752 22 12.0007C22 12.4262 21.6548 12.7714 21.2293 12.7714Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.2293 18.8192H2.77072C2.34522 18.8192 2 18.474 2 18.0485C2 17.623 2.34522 17.2778 2.77072 17.2778H21.2293C21.6548 17.2778 22 17.623 22 18.0485C22 18.474 21.6548 18.8192 21.2293 18.8192Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default HambergerIcon;
